export enum LoanTaskEnum {
  Applicant = 'Applicant',
  CoApplicant = 'CoApplicant',
  Invalid = 'Invalid',
  LiveApplication = 'LiveApplication',
  NoOffers = 'NoOffers',
  Review = 'Review',
  ViewOffers = 'ViewOffers',
}
